function createCountdownElm(counter, label) {
    return "<div><span class=\"module-countdown-banner-number\">" + counter + "</span><span class=\"module-countdown-banner-label\">" + label + "</span></div>";
};

$(document).ready(function () {
    $('.module-countdown-banner-countdown').each(function () {

        var countdownContainer = $(this);
        var endDateRaw = $('.module-countdown-hidden-enddate', countdownContainer).val();
        var labelDays = $('.module-countdown-hidden-days', countdownContainer).val();
        var labelHours = $('.module-countdown-hidden-hours', countdownContainer).val();
        var labelMins = $('.module-countdown-hidden-mins', countdownContainer).val();
        var labelSecs = $('.module-countdown-hidden-secs', countdownContainer).val();

        // Set the date we're counting down to
        var countDownDate = new Date(endDateRaw).getTime();

        // Update the count down every 1 second
        var x = setInterval(function () {

            // Get todays date and time
            var now = new Date().getTime();

            // Find the distance between now an the count down date
            var distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // If the count down is finished, clear and set to 0
            if (distance <= 0) {
                clearInterval(x);
                days = hours = minutes = seconds = 0;
            }

            // Update countdown HTML
            var newHtml = createCountdownElm(days, labelDays) +
                createCountdownElm(hours, labelHours) +
                createCountdownElm(minutes, labelMins) +
                createCountdownElm(seconds, labelSecs);

            countdownContainer.html(newHtml);
        }, 1000);

    });
});